// g2-request-reason-text.ts
//
// The operator-facing reason attached to a (re-)requested G2: why a new
// request exists (first request, plan changed after approval / while pending,
// invalidated by a redirect, older waive) plus where the approved content
// lives. Split out of g2-dispatch-gate-enforcement.ts (close-out 2026-09-30,
// 8b/8c pushed it past the 200-line budget) — moved verbatim.
import {
  describeG2PlanChange,
  type G2PlanSnapshot,
  hashG2PlanSnapshot,
} from "./g2-plan-content-snapshot.js";
import type { GateFile } from "./gate-registry.js";

type G2Record = GateFile["g2"];

export async function g2RequestReason(
  controlRoot: string,
  g2: G2Record,
  snapshot: G2PlanSnapshot,
  decisionReasons: readonly string[],
): Promise<string> {
  const change = await describeG2PlanChange(controlRoot, g2.artifact_hash, snapshot);
  const changed = change === "" ? "" : ` (${change})`;
  const legacy = g2.artifact_hash === undefined;
  const why =
    g2.status === "approved"
      ? legacy
        ? "approval G2 trước bản H4 không gắn nội dung plan ⇒ cần duyệt lại một lần"
        : `plan đổi sau khi duyệt G2 (request ${g2.request_id})${changed}`
      : g2.status === "pending"
        ? legacy
          ? "request G2 cũ không gắn nội dung plan ⇒ thay bằng request gắn hash plan"
          : `plan đổi khi G2 đang chờ duyệt — request ${g2.request_id} hết hiệu lực${changed}`
        : g2.status === "invalidated"
          ? "G2 bị vô hiệu (redirect đổi plan) ⇒ request lại theo plan hiện tại"
          : g2.status === "waived"
            ? "G2 đã waive nhưng plan nay cần người duyệt"
            : "plan đã xong, cần người duyệt";
  // Review L10: point the approver at what the id stands for.
  const snapshotFile = `g2-plan-snapshots/${hashG2PlanSnapshot(snapshot)}.json`;
  return [
    `${why} (nội dung được duyệt: ${snapshotFile} trong runtime của mission)`,
    ...decisionReasons,
  ].join(" · ");
}
